import type { SxProps } from "@mui/material"

const container: SxProps = {
  width: "100%"
}

const labelContainer: SxProps = {
  display: "flex",
  flexDirection: "row"
}

export default { labelContainer, container }
